const getQueryByKeyArray = (keys: string[]): string[] => {
  return keys.filter(Boolean).map((key) => {
    return `${key}=${key}`;
  });
};

export const getUrlByCondition = ({
  keyword,
  type,
  device,
  testingExperience,
  order,
  singlePageTest,
  redirectTest,
  replaceImage,
  displayPopup,
  notActive,
  competition,
  interim,
  paused,
  archived,
  editRequest,
  variation,
  advertising,
  closed,
}: {
  keyword: string;
  type: 'open' | 'targeting' | 'my_team' | 'limited_open' | 'private' | 'all';
  device: 'pc' | 'sp' | 'all';
  testingExperience: 'except' | 'only' | 'all';
  order: 'created_at_desc' | 'created_at_asc' | 'cvr_desc' | 'title_asc';
  singlePageTest: boolean;
  redirectTest: boolean;
  replaceImage: boolean;
  displayPopup: boolean;
  notActive: boolean;
  competition: boolean;
  interim: boolean;
  paused: boolean;
  archived: boolean;
  editRequest: boolean;
  variation: boolean;
  advertising: boolean;
  closed: boolean;
}): string => {
  return getQueryByKeyArray([
    // checkbox-group-1
    singlePageTest ? 'single_page_test' : '',
    redirectTest ? 'redirectTest' : '',
    replaceImage ? 'replaceImage' : '',
    displayPopup ? 'displayPopup' : '',
    //checkbox-group-2
    notActive ? 'notActive' : '',
    competition ? 'competition' : '',
    interim ? 'interim' : '',
    paused ? 'paused' : '',
    archived ? 'archived' : '',
    //checkbox-group-3
    editRequest ? 'editRequest' : '',
    variation ? 'variation' : '',
    //checkbox-group-4
    advertising ? 'advertising' : '',
    closed ? 'closed' : '',
  ])
    .concat([
      keyword !== '' ? `search=${keyword}` : '',
      type !== 'all' ? `type=${type}` : '',
      device !== 'all' ? `device=${device}` : '',
      testingExperience !== 'all' ? `testing_experience=${testingExperience}` : '',
      order ? `order=${order}` : 'order=created_at_desc',
    ])
    .filter(Boolean)
    .join('&');
};
